import { Component, OnInit, TemplateRef, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Requestactivitylog } from './requestactivitylog';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap';
import { RequestactivitylogService } from './requestactivitylog.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'ng2-bootstrap-modal';
//import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';

@Component({
  selector: 'app-requestactivitylog',
  templateUrl: './requestactivitylog.component.html',
  styleUrls: ['./requestactivitylog.component.css']
})
export class RequestactivitylogComponent implements OnInit {
  @Input() requestdetailid: number;
  @Input() requesttypeid: number;
  userlogs: any = [];
  
  userlogany: any = [];
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  constructor(
    private requestactivitylogService: RequestactivitylogService,
    private toastr: ToastrService
  ) {

  }

  ngOnInit() {
    debugger
    this.requestactivitylogService.GetById(this.requestdetailid).subscribe(res => {
          
      debugger
      var alldata = res;
      alldata.forEach(data => {
        if (data.requesttypeid == this.requesttypeid && data.requestdetailid == this.requestdetailid ) {
            this.userlogs.push({ userid: data.userid, firstname: data.firstname, createdon: data.createdon, status: data.status })
        }
      });
    }, error => { this.toastr.error('Error while getting activitylog data') });

   /* this.requestactivitylogService.Get().subscribe(res => {
          
      
      var alldata = res;
      alldata.forEach(data => {
        if (data.requesttypeid == this.requesttypeid && data.requestdetailid == this.requestdetailid ) {
            this.userlogs.push({ userid: data.userid, firstname: data.firstname, createdon: data.createdon, status: data.status })
        }
      });
    }, error => { this.toastr.error('Error while getting activitylog data') });*/
  }

  key: string = 'userlog'; //set default
  reverse: boolean = false;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  //  getAll() {
  //    this.requestactivitylogService.Get().subscribe(res => {
  //      this.userlogs = res;
  //      
  //      console.log(this.userlogs);
  //      console.log("sad" + res);
  //    }, error => { this.toastr.error('Error while getting data'); });
  //  }
}
